/**
 * TODO WADPL-1128 TEMP override stack - delete this file, and revert the sites marked with the same comment, once the
 * JIT_ FME stack has been cut over by repointing the original AWS parameters at it.
 *
 * Lets a tester aim FME requests at a second ('override') FME stack without a redeploy, by adding
 * `?fmestack=override` to the portal page URL. The value is read from the address bar on every request, so it only
 * applies while it is visible there - navigating to a URL without it returns that tab to the default stack. That is
 * deliberate: what you can see is what you get.
 *
 * The server ignores an absent parameter and rejects any value other than 'default' or 'override', so a typo fails
 * loudly rather than quietly running on the default stack. See FmeStackOverride.java.
 */
export const FME_STACK_PARAM = 'fmestack';

/**
 * The `fmestack` value currently in the browser address bar, or null when it is absent or empty.
 */
export function fmeStackParam(): string | null {
    return new URLSearchParams(window.location.search).get(FME_STACK_PARAM) || null;
}

/**
 * Query string fragment to append to an outbound API URL, or '' when no stack has been selected.
 *
 * @param separator '?' when the URL has no query string yet, '&' when it already has one.
 */
export function fmeStackQuery(separator: '?' | '&'): string {
    const stack = fmeStackParam();

    if (!stack) {
        return '';
    }

    console.warn(`${FME_STACK_PARAM}=${stack} - FME requests for this page are being sent to the ${stack} stack`);

    return `${separator}${FME_STACK_PARAM}=${encodeURIComponent(stack)}`;
}
